// Auth store entryfile
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

// Initial state
const state = {
  isAuthenticated: false,
  userId: null,
};

export default {
  actions,
  mutations,
  getters,
  state,
};
